import React from "react";
import { useNavigate } from "react-router-dom";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../../context/AuthContext";

const Bonus = () => {
  const navigate = useNavigate();
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  return (
    <div
      id="mc-animate-container"
      className="v-base v-detail-base fade-enter-done"
    >
      <div>
        <div className="mc-header-wrap">
          <div
            id="mc-header"
            className="mc-navbar-blue mc-receivingCenter mc-default-header am-navbar am-navbar-light"
          >
            <div
              onClick={() => navigate(-1)}
              className="am-navbar-left"
              role="button"
            >
              <span className="am-navbar-left-content">
                <span style={{ paddingLeft: "0" }} className="return_icon">
                  <svg
                    style={{ color: "black" }}
                    className="am-icon am-icon-left am-icon-lg"
                  >
                    <use xlinkHref="#left" />
                  </svg>
                </span>
              </span>
            </div>
            <div className="am-navbar-title">Bonus</div>
            <div className="am-navbar-right">
              <div className="to-record">
                <a href="/m/claimHistory">
                  <span className="more-icon claim am-navbar-title">
                    <svg className="am-icon am-icon-claim-history_f7cd9f7c am-icon-md">
                      <use xlinkHref="#claim-history_f7cd9f7c" />
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
          <div className="am-whitespace am-whitespace-sm mc-whitespace" />
        </div>
        <div
          className="mall-home-top"
          style={{
            "background-image": 'url("/assets/images/mall-bg.00c9d202.jpg")',
          }}
        >
          <div className="mall-header">
            <div className="profile-icon">
              <img
                src="https://images.0756931.com//TCG_PROD_IMAGES/B2C/01_PROFILE/PROFILE/0.png"
                alt
              />
            </div>
          </div>
          <div className="mall-number-info">
            <p className="mall-user-name">
              <span className="name-text">{user?.user?.username}</span>
            </p>
            <p className="mall-user-amount number-mc">৳ 0.00</p>
          </div>
        </div>
        <div className="reward-content">
          <div>
            <div className="collarCenter">
              <div style={{ visibility: "visible" }}>
                <div className="RAFFLE ticket-item ">
                  <div className="ticket">
                    <div className="ticket-card">
                      <div className="card-wrapper">
                        <span className="item-type">REWARD TICKET</span>
                        <span className="item-title">Red Package</span>
                        <span className="item-date">2025.12.19</span>
                      </div>
                    </div>
                    <div className="ticket-info">
                      <h3>
                        {/* react-text: 2663 */} {/* /react-text */}
                      </h3>
                      <div className="ticket-desc">
                        {/* react-text: 2665 */}Reward{/* /react-text */}
                        {/* react-text: 2666 */} :{/* /react-text */}
                        <span>দৈনিক পুরস্কার</span>
                      </div>
                    </div>
                  </div>
                  <div className="operating">
                    <div className="due-title">Due Date</div>
                    <p>
                      <span className="days ">
                        {/* react-text: 2672 */}0{/* /react-text */}
                        <i>Day</i>
                      </span>
                      <br />
                      <i className="count-down">23:59:27</i>
                    </p>
                    <span className="ticket-item-btn ">Claim</span>
                  </div>
                  {/* react-empty: 2677 */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bonus;
